import 'cross-fetch/polyfill';
import {getStoreData} from "../../../utils/getStoreData";
import {formDataCreator, UrlCreator} from "../../../utils/requestCreator";
import {SUB_VISIT1_DISEASES_OBJECT} from "../../../config/requestConstants";
import {GET} from "../../../config/requestConstants";
import showNotification  from "../../../containers/_commonComponents/notification/showErrorNotification";

export const VISIT1_DISEASES_IS_LOADING = 'VISIT1_DISEASES_IS_LOADING';
export const VISIT1_DISEASES_IS_ERROR = 'VISIT1_DISEASES_IS_ERROR';
export const VISIT1_DISEASES_IS_GET = 'VISIT1_DISEASES_IS_GET';
export const VISIT1_DISEASES_IS_EDITED = 'VISIT1_DISEASES_IS_EDITED';

function dataIsLoading() {
    return {
        type: VISIT1_DISEASES_IS_LOADING
    }
}

function dataIsError() {
    return {
        type: VISIT1_DISEASES_IS_ERROR
    }
}

function dataIsGet(data) {
    return {
        type: VISIT1_DISEASES_IS_GET,
        payload: data
    }
}

function dataIsEdited(data) {
    return {
        type: VISIT1_DISEASES_IS_EDITED,
        payload: data
    }
}


export function fetchVisit1DiseasesData(action = GET, filter = [], data = {}, isInitial = true, functionName) {
    return (dispatch, getState) => {
        const key = getStoreData(() => getState().profile.key);
        const URL = UrlCreator();
        const requestData = formDataCreator(action, SUB_VISIT1_DISEASES_OBJECT, data, key, filter, null, null, null, functionName);

        dispatch(dataIsLoading());

        return fetch(URL, {
            method: 'POST',
            body: requestData
        }).then((response) => {
            if (response.status !== 200) {
                dispatch(dataIsError());
                throw Error(response.statusText)
            }

            dispatch(dataIsLoading());
            return response.json();
        }).then((data) => {
            // eslint-disable-next-line
            if (data.status != 0) {
                showNotification(data);
                dispatch(dataIsError());
                return;
            }

            isInitial
                ? dispatch(dataIsGet(data))
                : dispatch(dataIsEdited(getStoreData(() => data.data)))
        })
    }
}
